const apiURL = process.env.REACT_APP_API_URL;

export async function getInstanceADM(client = "", model = "", token) {
  const apiUrl = `${apiURL}/admin/process/list/full`;
  let bodyData = {};
  if (model && model !== 'none') {
    bodyData.ModelId = model;
  }
  if (client && client !== 'none') {
    bodyData.ClientId = client;
  }

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(bodyData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}